import React from 'react';
import { Grid, withStyles } from '@material-ui/core';
import styles from './styles';

export type GroupPickupNumbersSectionProps = {
  classes: Record<string, string>;
  pickupNumbers?: Array<string | number | null | undefined>;
};

/**
 * Group dialog: lists all pickup numbers in the group (see group pickup spec).
 */
const GroupPickupNumbersSection: React.FC<GroupPickupNumbersSectionProps> = ({
  classes,
  pickupNumbers
}) => {
  const list = (pickupNumbers || []).filter(
    (n): n is string | number => n !== null && n !== undefined && n !== ''
  );
  if (!list.length) {
    return null;
  }
  return (
    <Grid item xs={12}>
      <div className={classes.statusTitleContainer}>
        <div className={classes.sectionTitle}>Pickups ({list.length})</div>
      </div>
      <div className={classes.infoContainer}>
        <div className={classes.groupPickupNumbers}>{list.join(', ')}</div>
      </div>
    </Grid>
  );
};

export default withStyles(styles)(GroupPickupNumbersSection);
